/**
 * Configuración de la aplicación.
 * Variables de negocio configurables sin necesidad de cambiar la lógica del código.
 */
export const APP_CONFIG = {
  CUADRE_FACTURA: {
    /**
     * Monto máximo de deuda pendiente para habilitar el cuadre automático.
     * Si la deuda actual de una factura en estado ABONO es menor o igual a
     * este valor, se mostrará la opción "Cuadrar diferencia" en el menú
     * de acciones y la fila se resaltará visualmente.
     *
     * Para deshabilitar completamente la funcionalidad, setear en 0.
     */
    MONTO_MAXIMO_DIFERENCIA: 1000,
  },
  EMISOR: {
    /**
     * Cuando es `false`, todas las sucursales emiten DTE como TAXTIC
     * (RUT por defecto). Activar cuando cada sucursal tenga su propia
     * API key Haulmer configurada en `sucursal.apiOpenFactura` y su
     * `sucursal.rutRazonSocial` validado contra el SII.
     */
    MULTIEMPRESA_HABILITADO: false,
    /**
     * RUT del emisor único usado mientras `MULTIEMPRESA_HABILITADO === false`.
     * Formato: dígitos + guion + DV (sin puntos).
     */
    RUT_EMISOR_DEFAULT: "76469207-1",
  },
};
